import {
  Defaults,
  nameplateFrameStyleHeight,
  nameplateFrameStyleLeft,
  nameplateFrameStyleTop,
  nameplateFrameStyleWidth,
  qrFrameStyleHeight,
  qrFrameStyleLeft,
  qrFrameStyleTop,
  qrFrameStyleWidth,
} from "@/custolink-views/asset_frontend/scan/Scan";

type TakePhotoReturnType = [string, {data: Uint8ClampedArray<ArrayBufferLike>, width: number, height: number}];

export default function takePhoto(mode:"qr"|"nameplate", vid : HTMLVideoElement) : TakePhotoReturnType{

  const canvas = document.createElement("canvas");

  canvas.width = Defaults.width;
  canvas.height = vid.videoHeight / (vid.videoWidth / Defaults.width);

  vid.setAttribute("height", canvas.height.toString());
  vid.setAttribute("width", canvas.width.toString());

  const context = canvas.getContext("2d") as CanvasRenderingContext2D;

  context.drawImage(vid, 0, 0, canvas.width, canvas.height);

  let frameTop,frameLeft, frameWidth, frameHeight;
  if(mode == "nameplate") {
    frameTop = nameplateFrameStyleTop * canvas.height;
    frameLeft = nameplateFrameStyleLeft * canvas.width;
    frameWidth = nameplateFrameStyleWidth * canvas.width;
    frameHeight = nameplateFrameStyleHeight * canvas.height;
  } else {
    frameTop = qrFrameStyleTop * canvas.height;
    frameLeft = qrFrameStyleLeft * canvas.width;
    frameWidth = qrFrameStyleWidth * canvas.width;
    frameHeight = qrFrameStyleHeight * canvas.height;
  }

  const croppedImageData = context.getImageData(frameLeft, frameTop, frameWidth, frameHeight);

  const cropCanvas = document.createElement("canvas")
   //cropCanvas = document.getElementById("canvasShit") as HTMLCanvasElement;
  cropCanvas.width = frameWidth;
  cropCanvas.height = frameHeight;

  const cropCtx = cropCanvas.getContext("2d")!;
  cropCtx.putImageData(croppedImageData, 0, 0);

  //console.log(cropCanvas, frameWidth, frameHeight)


  return [cropCanvas.toDataURL("image/png"), {width:croppedImageData.width,height:croppedImageData.height,data:croppedImageData.data}]
};